module.exports = __webpack_public_path__ + "static/img/NI@2x.2a8d141d.jpg";